import React from 'react';

const fmt = (p) => `R${Number(p).toLocaleString('en-ZA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

export function ProductPricingBlock({ original_price, final_price, savings, savingsPct }) {
  return (
    <div className="border border-[#E5E5E5] p-6 bg-[#F9F9F9]" data-testid="pricing-section">
      <div className="flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <span className="text-sm text-[#999999] font-work">Original Price</span>
          <span className="text-sm text-[#AAAAAA] line-through font-work" data-testid="original-price">{fmt(original_price)}</span>
        </div>
        <div className="border-t border-[#E5E5E5] pt-3 flex justify-between items-center">
          <span className="text-sm font-semibold text-[#D4AF37] font-work">HEIR LUXX Price</span>
          <span className="text-xl font-bold text-[#D4AF37] font-work" data-testid="final-price">{fmt(final_price)}</span>
        </div>
        {savingsPct > 0 && (
          <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 px-4 py-2.5 flex justify-between items-center">
            <span className="text-xs uppercase tracking-wider text-[#D4AF37] font-semibold font-work">You Save</span>
            <div className="text-right">
              <span className="text-sm font-bold text-[#D4AF37] font-work" data-testid="savings">{fmt(savings)}</span>
              <span className="text-xs text-[#D4AF37] ml-2 font-work">({savingsPct}% off)</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
